<template>
  <BaseModal
    :show="show"
    height="580px"
    title="Einführung"
    @close="$emit('close')"
  >
    <OnboardingBody @close="$emit('close')" />
  </BaseModal>
</template>

<script setup lang="ts">
import OnboardingBody from '@/application/components/OnboardingBody.vue';
import BaseModal from '@/application/components/BaseModal.vue';

defineProps<{ show: boolean }>();
defineEmits(['close']);
</script>
